export const whyChoosevanijyamData = {
    heading: "Why Choose Vanidya?",
    benefits: [
        {
            icon: "IconLeaf",
            title: "Satvik & Vegetarian Products",
            description: "Choose from a selection of vegetarian, Satvik, and ingredient-transparent products."
        },
        {
            icon: "IconSeedling",
            title: "Organic & Natural Choices",
            description: "Find products that are certified organic or naturally grown, when available."
        },
        {
            icon: "IconPray",
            title: "Selected Pooja Essentials",
            description: "Browse ritual items sourced for quality and tradition."
        },
        {
            icon: "IconBook",
            title: "Spiritual Books",
            description: "Discover books on spirituality, wellness, and Indian traditions."
        },
        {
            icon: "IconVerified",
            title: "Verified Sellers",
            description: "Shop from sellers who follow our quality and transparency guidelines."
        },
        {
            icon: "IconLock",
            title: "Clear, Secure Payments",
            description: "Pay safely with transparent pricing and no hidden fees."
        },
        {
            icon: "IconEco",
            title: "Eco-Aware Practices",
            description: "We encourage sustainable packaging and mindful sourcing."
        }
    ]
};